<template>
    <div class="profile-header">
        <div class="profile-header-picture">
            <img :src="profilePictureUrl">
        </div>
        <div class="profile-header-data">
            <span class="profile-header-data-fullname">{{profileFullname}}</span>
            <span class="profile-header-data-short-description" :class="shortDescriptionClass" @click="gotoSettings">{{profileShortDescription}}</span>
            <a target="blank" :href="profileLinkedinUrl" class="profile-header-data-linkedin" v-if="showLinkedIn" :class="linkedInClass" @click="gotoSettings"><img :src="require('@/assets/v3/img/icons/linkedin.svg')"><span>{{profileLinkedinUrl}}</span></a>
        </div>
    </div>
</template>

<i18n>
{
    "en": {
        "home": {
            "profile-header": {
                "addShortDescription": "...add a short description of yourself",
                "addLinkedIn": "...add your LinkedIn profile URL"
            }
        }
    },
    "es": {
        "home": {
            "profile-header": {
                "addShortDescription": "...añade una breve descripción de ti mismo",
                "addLinkedIn": "...añade la URL de tu perfil de LinkedIn"
            }
        }
    },
    "fr": {
        "home": {
            "profile-header": {
                "addShortDescription": "...ajoutez une brève description de vous-même",
                "addLinkedIn": "...ajoutez l'URL de votre profil LinkedIn"
            }
        }
    },
    "pt": {
        "home": {
            "profile-header": {
                "addShortDescription": "... acrescentar uma breve descrição de si próprio",
                "addLinkedIn": "... adicionar o URL do seu perfil do LinkedIn"
            }
        }
    },
    "de": {
        "home": {
            "profile-header": {
                "addShortDescription": "...fügen Sie eine kurze Beschreibung Ihrer Person hinzu",
                "addLinkedIn": "...Ihre LinkedIn-Profil-URL hinzufügen"
            }
        }
    },
    "nl": {
        "home": {
            "profile-header": {
                "addShortDescription": "...voeg een korte beschrijving van jezelf toe",
                "addLinkedIn": "...voeg je LinkedIn profiel URL toe"
            }
        }
    }
}
</i18n>

<script>
import { getModule } from '@/modules/store'
import ConfigStore from '@/modules/config/store/ConfigStore'

export default {
    components: {
    },
    props: {
    },
    data() {
        return {
            isLoading: false,
            originalItems: [],
            search: ''
        }
    },
    computed: {
        configStore() {
            return getModule(ConfigStore)
        },
        profilePictureUrl() {
            return this.configStore.user.pictureUrl || require('@/assets/v3/img/icons/user.png')
        },
        profileFullname() {
            return this.configStore.user.firstName + ' ' + this.configStore.user.lastName
        },
        hasProfileDescription() {
            return this.configStore.user.shortDescription ? true : false
        },
        profileShortDescription() {
            if (process.env.RECIPIENT_ADMIN) {
                return this.hasProfileDescription ? this.configStore.user.shortDescription : this.$t('home.profile-header.addShortDescription')
            } else {
                return this.configStore.user.shortDescription
            }
        },
        profileLinkedinUrl() {
            const url = 'https://www.linkedin.com/in/' + this.configStore.user.linkedinProfileUrl
            if (process.env.RECIPIENT_ADMIN) {
                return this.hasLinkedIn ? url : this.$t('home.profile-header.addLinkedIn')
            } else {
                return url
            }

        },
        hasLinkedIn() {
            return this.configStore.user.linkedinProfileUrl ? true : false
        },
        showLinkedIn() {
            if (process.env.RECIPIENT_ADMIN) {
                return true
            } else {
                return this.configStore.user.linkedinProfileUrl ? true : false
            }

        },
        shortDescriptionClass() {
            if (this.hasProfileDescription) {
                return ''
            } else {
                return 'no-desc'
            }
        },
        linkedInClass() {
            if (this.hasLinkedIn) {
                return ''
            } else {
                return 'no-linkedin'
            }
        }
    },
    methods: {
        gotoSettings(e) {
            if (this.hasProfileDescription) return
            this.$gotoRoute('user-settings')
            e.preventDefault()
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

$inside-width = 1260px
$outside-padding = 84px
$outside-width = $inside-width + ($outside-padding * 2)
$el-vertical-space = 10px

$content-max-width = 1000px
$responsive-mul = 0.1
$responsive-max-width = $outside-width
$responsive-min-width = $responsive-max-width * $responsive-mul

.profile-header
    display flex
    flex-direction row

    .profile-header-picture
        // width 140px
        // height 140px
        flex 0 0 auto
        responsive-styling-auto-scale(width, 140px, $responsive-max-width)
        responsive-styling-auto-scale(height, 140px, $responsive-max-width)
        background-color #e5e5e5
        position relative
        margin-right 12px
        border-radius 5px
        overflow hidden
        box-shadow 0px 0.821258px 1.64252px rgba(0, 0, 0, 0.25)

        img
            position absolute
            top 0
            left 0
            width 100%
            height 100%
            object-fit cover

    .profile-header-data
        flex 1 1 0
        display flex
        flex-direction column
        justify-content center
        min-width 0
        align-items flex-start
        justify-content flex-start

        .profile-header-data-fullname
            font-weight bold
            // font-size 60px
            line-height 1
            responsive-styling(font-size, 24px, 64px, $responsive-max-width * responsive-width-min-scale, $responsive-max-width)
            // responsive-styling-auto-scale(font-size, 64px, $responsive-max-width)
            // responsive-styling-auto-scale(line-height, 46px, $responsive-max-width)
            background linear-gradient(360deg, #FFD25F -44%, #23D7FF 115%)
            -webkit-background-clip text
            -webkit-text-fill-color transparent
            box-decoration-break clone
            -webkit-box-decoration-break clone
            margin 0

        .profile-header-data-short-description
            font-weight 400
            font-size 18px
            margin-bottom 8px

            &.no-desc
                opacity 0.4
                cursor pointer

        .profile-header-data-linkedin
            display flex
            align-items center
            text-overflow ellipsis
            white-space nowrap
            overflow hidden
            width 100%

            &.no-linkedin
                cursor pointer

            img
                width 22px
                margin-right 4px
                transition all 0.35s cubic-bezier(.41,2.24,.61,1)

            span
                responsive-styling(font-size, 16px, 18px, $responsive-max-width * responsive-width-min-scale, $responsive-max-width)
                transition transform 0.35s cubic-bezier(.41,2.24,.61,1), opacity 0.25s
                text-overflow ellipsis
                white-space nowrap
                overflow hidden

            &:hover

                opacity 1 !important

                img
                    transform scale(1.15)

                span
                    transform translateX(4px)
                    opacity 0.6


</style>



// WEBPACK FOOTER //
// src/modules/home/components/ProfileHeader.vue